const loggedKeys = new Set<string>();

export const logOnce = (key: string, ...args: unknown[]) => {
  if (loggedKeys.has(key)) return;
  console.log(...args);
  loggedKeys.add(key);
};
